import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Row  } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { Link, useOutletContext } from 'react-router-dom';
import Slider from "react-slick";
import { ASSET_URL } from '../../constant';
import Services from './../../service';
import { ADD_TO_CART } from '../../helpers';
import {  MySpinner } from '../index';

const RecommendSlider = (props) => {
    const { getCountCart } = useOutletContext();

    const [Recommend, setRecommend] = useState({})
    
    const [Qty, setQty] = useState('')
    const [Load, setLoad] = useState(false)

    useEffect(() => {
        getRecommend();
    }, [])

    const recommendSlick = {
        swipe: false,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                }
            },
        ]
    };

    const getRecommend = async () => {
        await Services.GetRecommendProducts()
        .then((res) => {
            setRecommend(res.data.products)
        }).catch((err) => {
            console.log('error Recommend Products:', err.response.data)
        })
    }

    const cardProductsRecommend = (data, key) => {
        // const mainImage = JSON.parse(data.image);

        // use Default Categories Photo
        const mainImage = JSON.parse(data.image)[0].url != "images/default-image-products.jpg" ?
        JSON.parse(data.image)[0].url :
        JSON.parse(data.category.thumbnail)[0].url;

        const addToCart = async (e) => {
            e.preventDefault();

            setLoad(true)
            await ADD_TO_CART(e, data.id, Qty)
            .then((res) => {
                setQty('')
                setLoad(false)
                getCountCart()
            })
        }

        return (
            <Card key={key} className="border border-1 rounded-0 product-home-card">
                {data.discount && <div className="discount" data-discount={`-`+data.discount+`% OFF`} /> }
                <Link to={'/products/'+ data.item_no} className="text-dark">
                    <Card.Body>
                        <div className="product-image">
                            <Card.Img variant="top" src={ASSET_URL + mainImage} className="rounded-0" alt={data.manufacture_no} />
                        </div>
                        <div className="product-detail">
                            <div className="product-name">
                                <p className="fs-5 m-0 fw-bold text-uppercase">{data.name}</p>
                                <p className="fs-6 fw-bold text-secondary text-uppercase">{data.brand && data.brand.name}</p>
                            </div>
                            <div className="product-desc" dangerouslySetInnerHTML={{__html: data.description}} />
                            <div className="product-item">
                            <p className="text-secondary text-uppercase"><span className="fw-bold">MI ITEM #</span> {data.item_no}</p>
                            </div>
                            <div className="product-stock">
                                <p>
                                    <FaCheckCircle className="fs-5 text-success" />
                                </p>
                                <p className="small">
                                    <b>Quote</b> <br />
                                    For Your Price & Availability Stock
                                </p>
                            </div>
                        </div>
                    </Card.Body>
                </Link>
                <div className="product-cart">
                    <span className="fs-5 fw-bold">Qty</span>
                    <Form>
                        <Form.Group className="input-group">
                            <Form.Control type="number"
                                name="qty"
                                autoComplete="off"
                                value={Qty}
                                onChange={(e) => setQty(e.target.value)}
                            />
                            <Button variant="info" type="button" onClick={(e) => addToCart(e)}>
                                Add to Quote
                            </Button>
                        </Form.Group>
                    </Form>
                </div>
            </Card>
        )
    }

    return (
        <>
            {Recommend.length !== undefined && 

                <Container id="recommend-section" fluid className="mt-5 p-4 bg-light">
                    {Load &&  <MySpinner/>}
                    <p className="m-0 fs-3 fw-bold has-after text-uppercase">Other Products</p>
                    <Row>
                        <Col lg={12} className="p-4">
                            <Slider {...recommendSlick}>
                                
                                {Recommend.length > 0 && Recommend.map((x, i) =>
                                    cardProductsRecommend(x,i)
                                )}

                            </Slider>
                        </Col>
                    </Row>
                </Container>
            
            }
        </>
    )
}

export default RecommendSlider
